"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventName = void 0;
const getEventName = (storeName, action) => {
    return `store_${storeName}_${action}`;
};
exports.getEventName = getEventName;
//# sourceMappingURL=utils.js.map